<template>
  <div class="content posire">
    <qx-line-chart :allCustomChartObj="chartObj" ref="line" height="400px" :width="width" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%',
    },
  },
  data () {
    return {
      chartObj: {
        xAxis: {
          type: 'category',
          data: [],
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        series: [],
      },
    };
  },
  methods: {
    setOptions (data) {
      this.$refs.line.setOptions(data);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  box-sizing: border-box;
  top: -0;
}
</style>
